import uuid from 'uuid/v4'

export default function useTimeForPartners(formData, setFormData) {
  const addTimeForPartner = () => {
    const currentTimeAttributes = formData.times_attributes || {}
    const firstNonPartnerTime: any = Object.values(currentTimeAttributes).find((time: any) => !time.partner_time) || {}
    const newTimeAttributes = {
      partner_id: null,
      partner_time: true,
      comment: firstNonPartnerTime.comment || '',
      time: firstNonPartnerTime.time || 0,
      worktype_id: firstNonPartnerTime.worktype_id || '',
      worktype: firstNonPartnerTime.worktype || {},
    }
    setFormData({
      ...formData,
      times_attributes: {
        ...currentTimeAttributes,
        [uuid()]: newTimeAttributes,
      },
    })
  }

  return { addTimeForPartner }

}
